export enum MainGridWrapperElements {
  SECTION = 'section',
  DIV = 'div',
  FOOTER = 'footer',
  HEADER = 'header',
  MAIN = 'main',
  UL = 'ul'
}
